/**
 * ChatButton: 채팅 패널 토글 버튼 (읽지 않은 메시지 뱃지 포함).
 *
 * v1 원본: RenewalComponents/Buttons/ChatButton/ChatButtonPresenter.js
 * v1 CSS: .rtc_new3 .newHeader_btnItem > .newHeader_btn
 */
import React from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { chatActions } from '@/store/slices/chatSlice';

const ChatButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const chat = useAppSelector((s) => s.chat);
  const ui = useAppSelector((s) => s.ui);

  const isActive = ui.openSideBar && ui.sidebarContent === 'chat';
  const unreadCount = chat.unreadCount ?? 0;

  const handleClick = () => {
    if (isActive) {
      dispatch(uiActions.setOpenSideBar(false));
    } else {
      dispatch(uiActions.setSidebarContent('chat'));
      dispatch(chatActions.clearUnread());
    }
  };

  return (
    <div className="newHeader_btnItem" onClick={handleClick}>
      <button type="button" className="newHeader_btn">
        <span className="newHeader_btnIcon icoChat" />
        <p className="newHeader_btnText">
          채팅
        </p>
        {unreadCount > 0 && (
          <span className="newHeader_btnBadge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default ChatButton;
